import React from 'react';
import { useDeliveryHistory } from '../hooks/useDeliveryHistory';
import { DeliveryHistory } from '../types/deliveryHistory.types';
import DeliveryFilterSection from './DeliveryFilterSection';
import DeliveryTable from './DeliveryTable';
import Loading from '@/shared/components/feedback/Loading';
import '@/shared/styles/search-form.css';
import '../styles/DeliveryHistoryPage.css';

const DeliveryHistoryPage: React.FC = () => {
    const {
        deliveryHistoryData,
        loading,
        error,
        filter,
        searchedFilter,
        page,
        limit,
        totals,
        pageTotals,
        partners,
        partnersLoading,
        statusCodes,
        statusLoading,
        userType,
        handleFilterChange,
        handleSearch,
        handleReset,
        handlePageChange,
        renderOperationStatus,
    } = useDeliveryHistory();

    const handleRowClick = (row: DeliveryHistory) => {
        try {
            const dateFilter = searchedFilter || null;
            const payload: {
                suppId: string;
                suppName: string;
                riderId: string;
                riderName: string;
                startDate?: string;
                endDate?: string;
            } = {
                suppId: row.supplyId ? String(row.supplyId) : '',
                suppName: row.suppName || '',
                riderId: row.riderId,
                riderName: row.riderName || '',
            };
            if (dateFilter) {
                payload.startDate = dateFilter.startDate || '';
                payload.endDate = dateFilter.endDate || '';
            }
            sessionStorage.setItem('deliveryHistoryDetailPrefill', JSON.stringify(payload));
            sessionStorage.setItem('deliveryHistoryDetailPrefillSource', 'history');
        } catch (err) {
            console.warn('Failed to store delivery history detail prefill:', err);
        }
        window.dispatchEvent(new CustomEvent('dashboard:navigate', { detail: { page: 'delivery_history_detail' } }));
    };

    if (loading) {
        return (
            <div className="delivery-history-page">
                <Loading />
            </div>
        );
    }

    if (error) {
        return (
            <div className="delivery-history-page">
                <div className="empty-state">
                    <h3>오류가 발생했습니다</h3>
                    <p>배달 내역을 불러오는 중 오류가 발생했습니다. 다시 시도해주세요.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="delivery-history-page">
            <div className="page-header">
                <h1 className="page-title">배달 내역 조회</h1>
            </div>

            <DeliveryFilterSection
                filter={filter}
                userType={userType}
                partners={partners}
                partnersLoading={partnersLoading}
                statusCodes={statusCodes}
                statusLoading={statusLoading}
                onFilterChange={handleFilterChange}
                onSearch={handleSearch}
                onReset={handleReset}
            />

            {deliveryHistoryData?.data && deliveryHistoryData.data.length > 0 && (
                <div className="result-count">
                    <i className="fas fa-list" />
                    검색 결과: <strong>{deliveryHistoryData.total.toLocaleString()}건</strong>
                </div>
            )}

            <DeliveryTable
                deliveryHistoryData={deliveryHistoryData}
                page={page}
                limit={limit}
                totals={totals}
                pageTotals={pageTotals}
                renderOperationStatus={renderOperationStatus}
                onPageChange={handlePageChange}
                onRowClick={handleRowClick}
            />
        </div>
    );
};

export default DeliveryHistoryPage;
